"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlags = exports.LdContextKey = void 0;
const React = __importStar(require("react"));
const mf_app_1 = require("@4r/mf-app");
exports.LdContextKey = 'LDContext';
function getSharedComponentContext() {
    return typeof window !== 'undefined' ? React.useContext((0, mf_app_1.getSharedComponent)(exports.LdContextKey)) : null;
}
function useFeatureFlag(key) {
    var _a, _b;
    const flags = (_b = (_a = getSharedComponentContext()) === null || _a === void 0 ? void 0 : _a.flags) !== null && _b !== void 0 ? _b : {};
    return flags[key];
}
exports.default = useFeatureFlag;
function useFlags() {
    var _a, _b;
    return (_b = (_a = getSharedComponentContext()) === null || _a === void 0 ? void 0 : _a.flags) !== null && _b !== void 0 ? _b : {};
}
exports.useFlags = useFlags;
